<template>
  <v-dialog v-model="bDialog" max-width="600" persistent>
    <v-card class="dialog-header-radius">
      <v-toolbar height="45" elevation="0" dense>
        <v-toolbar-title class="text-title-modal">
            {{ oEquivalencias.ttlAdminLicencias }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn color="icon_close" icon small rounded class="mr-1" @click="__onClose">
            <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider class="mb-3"/>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
                <v-col sm="12" md="12" lg="12" xl="12" cols="12">
                    <span>{{ oEquivalencias.cmpTipoConexion }}</span>
                    <v-text-field hide-details="auto" disabled outlined dense :value="oItem?.Tipo"/>
                </v-col>
                <v-col sm="12" md="6" lg="6" xl="6">
                    <span>{{ oEquivalencias.cmpLicenciaEnUso }}</span>
                    <v-text-field hide-details="auto" disabled outlined dense :value="oItem?.Conteo"/>
                </v-col>
                <v-col sm="12" md="6" lg="6" xl="6">
                    <span>{{ oEquivalencias.cmpNoLicencias }}</span>
                    <v-text-field 
                        hide-details="auto" 
                        type="number" 
                        min="-1"
                        outlined 
                        dense 
                        :value="oItem?.Licencias" 
                        v-model="nLicencias"
                        :rules="nroLicenceRules"
                    />
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" class="d-flex justify-center">
                    <v-btn rounded outlined color="primary" @click="__onClose" class="mr-2">
                        {{ oEquivalencias.btnCancelar }}
                    </v-btn>
                    <v-btn rounded color="primary" @click="__onActualizar" :disabled="nLicencias == parseInt(oItem?.Licencias) ">
                        {{ oEquivalencias.btnActualizar }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import axiosServices from '@/services/axiosServices.js'
export default {
  name: "EditarLicencias",
  data() {
    return {
      bDialog: false,
      oItem: {},
      nLicencias: 0,
      oEquivalencias: this.$store.state.jsIdioma.oEquivalencias,
      valid: true,
      nroLicenceRules: [
        v => !!v || `El campo ${this.oEquivalencias.cmpNoLicencias} es Obligatorio`,
        v => (v >= -1) || `El valor debe ser mayor o igual a -1` 
      ],
    };
  },
  watch: {
    nLicencias(newValue) {
        if (newValue !== null && newValue !== undefined && isNaN(parseInt(newValue))) {
            this.nLicencias = parseInt(newValue);
        }
    }
  },
  methods: {
    __onClose() {
        this.bDialog = false;
        this.oItem = {}
    },
    async __onActualizar() {
        try {
            this.valid = this.$refs.form.validate()            
            if(!this.valid) return;

            let sMessage = '';
            let sText    = '';
            
            const { Licencias, Tipo, idLicencias } = this.oItem;            
            if( parseInt(this.nLicencias) > parseInt(Licencias) ) {
                sMessage = '¿Está seguro de realizar el aumento en las licencias?'
            } else if (parseInt(this.nLicencias) < parseInt(Licencias) ) {
                sMessage = '¿Está seguro de realizar la disminución en las licencias?'
            } 
            if (parseInt(this.nLicencias) === 0 ){
                sMessage = '¿Está seguro de dejar la cantidad de licencias en 0?'
                sText = 'Tenga en cuenta que al realizar esta operación no se permitirá el acceso a los usuarios'
            } 
            
            if( parseInt(this.nLicencias) === -1 ){
                sMessage = '¿Está seguro de eliminar el monitoreo de licencias?'
                sText = 'Tenga en cuenta que al realizar esta operación, no se realizará seguimiento de licencias.'
            }
            
            this.$swal.fire({
                title: 'Información',
                html: `${sMessage} <br> <small>${sText}</small>`,
                showCancelButton: true,
                confirmButtonText: this.oEquivalencias.btnAceptar,
                cancelButtonText: this.oEquivalencias.btnCancelar,
                reverseButtons: true
            }).then( async (result) => {
                if (result.isConfirmed) {
                    let oBody = {
                        tipo: Tipo,
                        idLicencias: idLicencias,
                        subdominio: this.oItem.sSubdominio,
                        NoLicencias: this.nLicencias,
                        valorLicenciaAnterior : this.oItem.Licencias
                    }
                    const { nStatusCode } = await axiosServices.putConfiguration(`licencias`, oBody)
                    if(nStatusCode === 200) {
                        setTimeout(() => this.onNotify(), 500);
                        this.$emit('onConfirm')
                        this.bDialog = false;
                    }
                }
            })

            
        } catch (error) {
            error;
        }
    },
    onNotify() {
        this.$store.dispatch('notificaciones/SetColor','success')
        this.$store.dispatch('notificaciones/SetMensaje','Notificación: Cambio realizado')
        this.$store.dispatch('notificaciones/ShowNotificacion',true);
    }
  }
};
</script>